import React, { useEffect, useState } from "react";
import { unitUsahaTable } from "./unitUsahaTable";
import { unitUsahaFormData } from "./unitUsahaFormData";

// API
import {
  getAllDataTableUnitUsaha,
  insertNewUnitUsaha,
  updateUnitUsaha,
  deleteUnitUsaha,
} from "./api/unitUsahaAPI";
import { getDropdownBidangUsaha } from "views/admin/config/bidangUsaha/api/bidangUsahaAPI";
// import { getDropdownUsers } from 'views/admin/config/user/api/userAPI';

// Component
import CardTable from "components/Cards/CardTable";
import FormCustom from "components/Forms/FormCustom";
import ConfirmModal from "components/Modal/ConfirmModal";

import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router";
import { getDropdownPelanggan } from "../pelanggan/api/pelangganAPI";

export default function UnitUsaha() {
  const history = useHistory();

  const [addForm, setAddForm] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [editFormValue, setEditFormValue] = useState(null);

  const [dataTable, setDataTable] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  const [formData, setFormData] = useState(null);

  const [formDataArr, setFormDataArr] = useState([]);

  // Select-Option Data
  // const [listFilterDropdown, setListFilterDropdown] = useState([])
  const [dropdownBidangUsaha, setDropdownBidangUsaha] = useState(null);
  //   const [dropdownUsers, setDropdownUsers] = useState(null);
  const [dropdownPelanggan, setDropdownPelanggan] = useState(null);

  // type Search
  const [typeSearch, setTypeSearch] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);
  const [deletePopUp, setDeletePopUp] = useState([{ show: false, id: null }]);

  // Component is Active ?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // handle when state active changed
  useEffect(() => {
    setIsLoading(true);

    getAllDataTableUnitUsaha()
      .then((response) => {
        active === true && setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));

    return () => {
      setDataTable([]);
    };
  }, [active]);

  // Select-Option Data
  // Load Dropdown Bidang Usaha
  useEffect(() => {
    setIsLoading(true);

    getDropdownBidangUsaha()
      .then((response) => {
        setDropdownBidangUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownBidangUsaha([]);
    };
  }, [active]);

  // Load Dropdown Users
  useEffect(() => {
    setIsLoading(true);

    getDropdownPelanggan()
      .then((response) => {
        setDropdownPelanggan(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownPelanggan([]);
    };
  }, [active]);

  // Add Dropdown Bidang Usaha to ListFilterDropdown
  // useEffect(() => {

  //     if(dropdownBidangUsaha !== null) {
  //         setIsLoading(true);
  //         setListFilterDropdown(dropdownBidangUsaha, [...listFilterDropdown])
  //         setIsLoading(false);
  //     }

  // }, [dropdownBidangUsaha, listFilterDropdown])

  // Add Dropdown Users to ListFilterDropdown
  // useEffect(() => {

  //     if(dropdownUsers !== null) {
  //         setIsLoading(true);
  //         setListFilterDropdown(dropdownUsers, [...listFilterDropdown])
  //         setIsLoading(false);
  //     }

  // }, [dropdownUsers, listFilterDropdown])

  // End Select-Option Data

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(unitUsahaFormData(dropdownBidangUsaha, dropdownPelanggan));

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownBidangUsaha, dropdownPelanggan]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, [active]);

  // Handle When User Click Add Button
  function handleInsert() {
    setActive(false);
    setAddForm(true);
  }

  // Handle When User Click Cancel Button
  const handleCancelButton = () => {
    setAddForm(false);
    setEditForm(false);
    setEditFormValue(null);
    setFormData(null);
    setActive(true);
  };

  // Handle When User Click Edit Button
  const handleEdit = (rowData) => {
    setActive(false);
    setEditFormValue(rowData);
    setEditForm(true);
  };

  // Handle When User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_unit_usaha,
    });
  };

  // Handle When User Confirm to Delete Data
  const handleDeleteTrue = () => {
    setActive(false);
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteUnitUsaha(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle When User Deny to Confirm Delete Data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle When User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewUnitUsaha(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  // Handle When User Submit Update Data
  const handleUpdateSubmit = (e) => {
    e.preventDefault();
    if (formData !== null) {
      const id = editFormValue.id_unit_usaha;

      setIsLoading(true);

      updateUnitUsaha(formData, id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    } else {
      toast.error(`Tidak ada data yang di ubah.`);
    }
  };

  // Check If Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setFormData(null);
        setAddForm(false);
        setEditForm(false);
        setActive(true);
        history.push("/masterData/UnitUsaha");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Set Inputed Data to Form
  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  // Handle When Submit Process End
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setIsLoading(false);
  };

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when Searching Changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getAllDataTableUnitUsaha(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getAllDataTableUnitUsaha()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              // getData = {getData}
              editFormValue={null}
            />
          </div>
        </div>
      </div>
    );

  if (editForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Edit Data"}
              formDataArr={formDataArr}
              handleSubmit={handleUpdateSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={editFormValue}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {deletePopUp.show && (
            <div>
              <ConfirmModal
                handleIfTrue={(e) => handleDeleteTrue()}
                handleIfFalse={(e) => handleDeleteFalse()}
              />
            </div>
          )}
          <Toaster />
          <CardTable
            tableTitle="Tabel Master Unit Usaha"
            cols={unitUsahaTable(handleEdit, handleDelete)}
            handleInsert={(e) => handleInsert()}
            handleSearch={handleSearch}
            data={dataTable}
            pageNumber={pageNumber}
            changePage={changePage}
          />
        </div>
      </div>
    </div>
  );
}
